/* eslint-disable no-lone-blocks */

import './styling/App.css';
import './styling/navbar-account-mobile.css';
// import Amplify from 'aws-amplify';
import {__s3FileStreamDownload} from './helper_classes/AWSS3'

import {Buffer} from 'buffer';

// Reactjs.
import React, {Component, useEffect, useLayoutEffect, useRef, useState} from 'react';
import {BrowserRouter, Routes, Route, Link, NavLink, useLocation} from "react-router-dom";
import { Button, Navbar, Nav, Form, FormControl, Row, Col, Image, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

//import useGaTracker from './useGaTracker'
import ReactGA from "react-ga";

// import {Auth, Storage} from 'aws-amplify'

// Logo.
import xenkia_logo from './icons/xenkia32x32.png'
import individual from './icons/individual.png'
import company from './icons/enterprise.png'

// Javascript files of other /pages.
import Signup from "./pages/signup_v1";
import AssetManager from './pages/assetmanager/assetmanager.js';
import Profile from './pages/profile';
import Home from './pages/home';
import FAQ from './pages/faq';
import Contact from './pages/contact';
import LiveDemo from './pages/liveDemo';
import ChangeTemporaryPassword from './pages/ChangeTemporaryPassword'
import Unsubscribe from './pages/unsubscribe'

import {cognitoAuthenticateUser, cognitoGetCurrentUser, cognitoSignout}  from './helper_classes/identity'
import {postJson} from './helper_classes/http'
//import cognitoGetCurrentUser  from './helper_classes/identity'
 


// Configure AWS.
// Amplify.configure(awsconfig);


// User details needed for account operations obtained from the remote server.
export var loggedinUsersEmail   = "";

const LOGIN_STATUS = Object.freeze({
  SIGNED_OUT: 0,
  SIGNING_IN: 1,
  SIGNED_IN: 2,
  SIGNING_OUT: 3
});

const DEFAULT_PROFILE_MIME_TYPE = 'image/jpeg';

const PROFILE_PICTURE_KEYS = [
  'profilePicture/profile-picture',
  'profilePicture/profile-picture.jpg',
  'profilePicture/profile-picture.jpeg',
  'profilePicture/profile-picture.png',
  'profilePicture/profile-picture.webp'
];

function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => setIsVisible(window.scrollY > 320);

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, {passive: true});

    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);

  const scrollToTop = () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top: 0, behavior: reduceMotion ? 'auto' : 'smooth'});
  };

  return (
    <button
      type="button"
      className={`back-to-top${isVisible ? ' is-visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Back to top"
      title="Back to top"
      aria-hidden={!isVisible}
      tabIndex={isVisible ? 0 : -1}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 19V5m0 0 6 6m-6-6-6 6" />
      </svg>
      <span className="back-to-top-label">Top</span>
    </button>
  );
}

function ScrollToTopOnRouteChange() {
  const {pathname} = useLocation();

  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo({top: 0, left: 0, behavior: 'auto'});
  }, [pathname]);

  return null;
}

function SiteNavbar({stateUpdate}) {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [expanded, setExpanded] = useState(false);
  const [scrollY, setScrollY] = useState(() => window.scrollY);
  const navbarRef = useRef(null);

  useEffect(() => {
    const updateScrollPosition = () => setScrollY(window.scrollY);

    updateScrollPosition();
    window.addEventListener('scroll', updateScrollPosition, {passive: true});

    return () => window.removeEventListener('scroll', updateScrollPosition);
  }, []);

  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!expanded) return undefined;

    const closeOnOutsideClick = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener('click', closeOnOutsideClick, true);
    return () => document.removeEventListener('click', closeOnOutsideClick, true);
  }, [expanded]);

  const backgroundProgress = isHome ? Math.min(scrollY / 120, 1) : 1;
  const isAtTop = isHome && scrollY <= 2;

  return (
    <Navbar
      ref={navbarRef}
      bg="dark"
      variant="dark"
      sticky="top"
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
      className={`site-navbar${isHome ? ' site-navbar-home' : ''}${isAtTop ? ' is-at-top' : ''}${expanded ? ' is-expanded' : ''}`}
      style={{
        '--site-navbar-bg-alpha': isHome ? (expanded ? 0.75 : backgroundProgress * 0.75) : 0.97,
        '--site-navbar-border-alpha': isHome && !expanded ? backgroundProgress * 0.08 : 0.08,
        '--site-navbar-shadow-alpha': isHome && !expanded ? backgroundProgress * 0.16 : 0.16,
        '--site-navbar-blur': `${isHome && !expanded ? backgroundProgress * 14 : 14}px`
      }}
    >
      <Image className="site-navbar-logo" src={xenkia_logo} alt="Xenkia"/>
      <Navbar.Brand as={Link} to="/" className="site-navbar-brand">Xenkia</Navbar.Brand>
      <Navbar.Toggle aria-controls="site-navbar-collapse" aria-label="Toggle navigation"/>
      <SigninForm stateUpdate={stateUpdate} setNavbarExpanded={setExpanded}/>
    </Navbar>
  );
}

function inferProfileMimeTypeFromKey(key) {
  if (key.endsWith('.png')) {
    return 'image/png';
  }

  if (key.endsWith('.webp')) {
    return 'image/webp';
  }

  return 'image/jpeg';
}

// Class defintion.
class App extends Component{

  // Constructor.
  constructor(props) {
    super(props);

    this.stateUpdate = this.stateUpdate.bind(this);
  }

  // State variable.
  state = {
    loggedIn:           false
  }

  // This handler will be send to the SigninForm, so that it can update the loggedIn state.
  // Note: https://stackoverflow.com/questions/35537229/how-can-i-update-the-parents-state-in-react
  stateUpdate(loggedInState) {
    this.setState({
      loggedIn:   loggedInState
    })
  }


  // Do these things before loading anyting else.
  componentDidMount()
  {
    //useGaTracker();
    ReactGA.initialize("UA-220179500-1");
    
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  

    
  render(){
    return(
      <div className="App">    
        <BrowserRouter>
            <ScrollToTopOnRouteChange />
            <SiteNavbar stateUpdate={this.stateUpdate}/>


          {// A <Routes> looks through its children <Route>s and renders the first one that matches the current URL.
          }
              <Routes>
                <Route path="/assetmanager" 
                    element={<AssetManager
                        loggedIn = {this.state.loggedIn}
                      />}
                >    
                </Route>

                {/* <Route path="/asseteditor" 
                    element={<AssetEditor
                        loggedIn = {this.state.loggedIn}
                      />}
                >    
                </Route> */}

                <Route path="/profile"
                    element={<Profile
                        loggedIn = {this.state.loggedIn}
                    />}
                >
                </Route>
                <Route path="/faq" element={<FAQ/>} />
                <Route path="/contact" element={<Contact/>} />
                <Route path="/live-demo" element={<LiveDemo/>} />
                {/* <Route path="/signupform/:plan?/:cycle?/:cost?" */}
                <Route path="/signupform"
                    element={<Signup/>}>
                </Route>
                <Route path="/changetemporarypassword/:email?/:pass?"
                    element={<ChangeTemporaryPassword/>}>
                </Route>
                <Route path="/unsubscribe/:email?"
                    element={<Unsubscribe/>}>
                </Route>
                <Route path="/" 
                  element={<Home/>}>
                  {/* <Home/> */}
                </Route>
              </Routes>
              <BackToTopButton />
        </BrowserRouter>        
      </div>

    )
  }
}


/**
   * All the signin from related logic will go here.
   * @returns 
   */
 const SigninForm = (props) => {
    const {stateUpdate, setNavbarExpanded} = props;

    const [state, setState] = useState({
      email: null,
      name: null,
      loginstatus: LOGIN_STATUS.SIGNING_IN
    });

    // This State variable will store the Profile Picture in Base64 format. As soon as it gets updated, the picture gets displayed.
    const [profilePictureBase64, setProfilePictureBase64] = useState(null);
    const [profilePictureMimeType, setProfilePictureMimeType] = useState(DEFAULT_PROFILE_MIME_TYPE);

    // Username and Password references.
    const usernameRef = useRef(null);
    const passwordRef = useRef(null);
    const signInInProgressRef = useRef(false);

    // This flag will mark if the Image/Icon was uploaded by the user.
    const [image_icon_uploaded, setImage_icon_uploaded]       = useState(false);
    // Is this user an Individual or Company, regardless of which package was selected during Signup.
    const [individual_or_company]   = useState("Individual");

    // Check if any user is already logged in when this component mounts.
    useEffect(() => {
      let componentMounted = true;

      // Currently Login in.
      setState({email: null, name: null, loginstatus: LOGIN_STATUS.SIGNING_IN});

      // Check if any user is already logged in.
      cognitoGetCurrentUser()
      .then(async(refreshedCredentials) => {
          if(componentMounted === false) {
            return;
          }

          // Login successful.
          setState({email: refreshedCredentials.email, name: refreshedCredentials.name, loginstatus: LOGIN_STATUS.SIGNED_IN});
          loggedinUsersEmail = refreshedCredentials.email;

          // Set it to true, since the other pages needs to know if a user has been logged in or not in order to show the content.
          // Note: https://stackoverflow.com/questions/35537229/how-can-i-update-the-parents-state-in-react
          stateUpdate(true);

          // check if the Profile Picture was uploaded by the user. If yes, then load and display it.
          displayProfilePicture(refreshedCredentials.email);
      })
      .catch(() => {
          if(componentMounted === false) {
            return;
          }

          loggedinUsersEmail = "";
          setState({email: null, name: null, loginstatus: LOGIN_STATUS.SIGNED_OUT});
          stateUpdate(false);
      });

      return () => {
        componentMounted = false;
      }
    }, [stateUpdate]);

    


    /**
     * Asynchronous SignIn() function. 
     * Note: Solve how to change the state variable externally based on this article: https://stackoverflow.com/questions/37513440/set-react-component-state-from-outside-of-component, 
     * and https://twitter.com/dan_abramov/status/824308413559668744/photo/2
     */
    async function signIn(event) {

      event.preventDefault();

      if (state.loginstatus === LOGIN_STATUS.SIGNING_IN) {
        return;
      }

      if (signInInProgressRef.current) {
        return;
      }

      signInInProgressRef.current = true;

      const usernameValue = usernameRef.current?.value;
      const passwordValue = passwordRef.current?.value;

      if(usernameValue == null || passwordValue == null)
      {
        setState({email: null, name: null, loginstatus: LOGIN_STATUS.SIGNED_OUT});
        signInInProgressRef.current = false;
        return;
      }

      //console.log("check credentials");

      // Currently Login in.
      setState({email: null, name: null, loginstatus: LOGIN_STATUS.SIGNING_IN});

      try {
          //const user = await Auth.signIn(username.current.value, password.current.value);

          // // Verify credentials against the database.
          // var res = await fetch("https://dmomfne4b7.execute-api.us-east-1.amazonaws.com/prod/verifycredentials", {
          //     method: 'POST',
          //     // mode: 'no-cors',
          //     body: JSON.stringify({
          //         email:     username.current.value,
          //         //email:     "neuropac28@hotmail.com",
          //         password:  password.current.value
          //         //password:  "123456789"
          //     })
          // });


          // // Convert the response from the Backend to JSON.
          // var response = await res.json();
          
            


          /**
           *  Get a valid AWS Credential.
           */
          const refreshedCredentials = await cognitoAuthenticateUser({
              username: usernameValue,
              password: passwordValue
          });

              // The credentials can be accessed either via the returned variable (refreshedCredentials) locally, or via AWS.config.credentials globally.
              //console.log("Returned Credentials: ", refreshedCredentials.credentials, AWS.config.credentials);
              //console.log(AWS.config.credentials);

              // Login successful.
              setState({email: refreshedCredentials.email, name: refreshedCredentials.name, loginstatus: LOGIN_STATUS.SIGNED_IN});
              loggedinUsersEmail = refreshedCredentials.email;
              //console.log(refreshedCredentials.email, refreshedCredentials.name);

              // Set it to true, since the other pages needs to know if a user has been logged in or not in order to show the content.
              // Note: https://stackoverflow.com/questions/35537229/how-can-i-update-the-parents-state-in-react
              stateUpdate(true);

              // check if the Profile Picture was uploaded by the user. If yes, then load and display it.
              displayProfilePicture(refreshedCredentials.email);

          

      //   let res = await fetch("https://1ocjsd3q3f.execute-api.us-east-1.amazonaws.com/prod/user-pool-management", {
      //                   method: 'POST',
      //                   body: JSON.stringify({
      //                     request_type:   "authenticateUser",
      //                     username:       username.current.value,
      //                     password:       password.current.value
      //                   })
      //               })
          
      //     // Get the response from the Backend.
      //     const response = await res.json();

          

      //     // Proceed only if the user exists and the password was correct.
      //     if(response.statusCode === 200)
      //     {
      //         AWS.config.credentials = JSON.parse(response.body);
      //         //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
              // AWS.config.credentials.refresh(error => {
              //     if (error) {
              //       console.error(error);
              //     } else {
              //       // Instantiate aws sdk service objects now that the credentials have been updated.
              //       //var s3 = new AWS.S3();
              //       console.log(AWS.config.credentials);
              //     }
              // });

      //         // Login successful.
      //         setState({email: response.body.email, name: response.body.name, loginstatus: 2});

      //         // Save the email address of the currently logged in user, so that this can be used by other *.js files to extract data from the server.
      //         loggedinUsersEmail  = response.body.email;
      //         loginToken          = response.body.token;

      //         //console.log(loggedinUsersEmail);

      //         // Save the LoginToken for later use.
      //         //loginToken = response.body.
      //     }
      } catch (error) {
          loggedinUsersEmail = "";
          console.log('ERROR: ', error.message);

          // Login unsuccessful.
          setState({email: null, name: null, loginstatus: LOGIN_STATUS.SIGNED_OUT});
          alert(error?.errMessage || error?.message || 'Sign in failed. Please try again.');
      } finally {
          signInInProgressRef.current = false;
      }
    }




    /**
     * Signout the currently logged user from Cognito.
     */
    async function signOut() {

      // Currently Logging out.
      //setState({email: null, name: null, loginstatus: 3});

      // This function will SignOut the currently logged in user from Cognito.
      cognitoSignout();

      // Successfully logged out.
      loggedinUsersEmail = "";
      setState({email: null, name: null, loginstatus: LOGIN_STATUS.SIGNED_OUT});
      setImage_icon_uploaded(false);
      setProfilePictureBase64(null);
      setProfilePictureMimeType(DEFAULT_PROFILE_MIME_TYPE);

      // Set it to true, since the other pages needs to know if a user has been logged in or not in order to not to show the content.
      stateUpdate(false);

      // try {
      //     //await Auth.signOut();
      //     //console.log("signout");

      //     // Successfully logged out.
      //     setState({email: null, name: null, loginstatus: 0});

      //     // Set it to true, since the other pages needs to know if a user has been logged in or not in order to not to show the content.
      //     props.stateUpdate(false);

      //     // Go to Home page. 
      //     //console.log(window.location.href);
      //     if (window.location.href !== window.location.origin)
      //     {
      //         window.location.assign(window.location.origin);
      //     }
      // } catch (error) {
      //     console.log('ERROR: ', error.message);

      //     // Successfully logged out.
      //     setState({email: null, name: null, loginstatus: 2});
      // }
    }


    /** 
    * Display profile picture, if any was uploaded.
    */
    const displayProfilePicture = async(email) =>
    {
        if (!email) {
          return;
        }

        var response = await postJson("https://oidnlpynvl.execute-api.us-east-1.amazonaws.com/prod/accountstatus", {
            email
        });

        // Proceed only if the Response StatusCode=201.
        if(response.statusCode === 201)
        {
            // If the Icon was uploaded by the user, then display it in the browser.
            if(response.body.response.Item.image_icon_uploaded === true)
            {
                for (const key of PROFILE_PICTURE_KEYS) {
                  try {
                    const dataStream = await __s3FileStreamDownload({
                      bucketName: 'xenkiaassetbucket',
                      subPath: key
                    });

                    if (dataStream?.data?.Body) {
                      setProfilePictureBase64(Buffer.from(dataStream.data.Body).toString('base64'));
                      setProfilePictureMimeType(dataStream?.data?.ContentType || inferProfileMimeTypeFromKey(key));
                      setImage_icon_uploaded(true);
                      return;
                    }
                  }
                  catch(e) {
                    // Try next key.
                  }
                }
            }
            else {
              setImage_icon_uploaded(false);
              setProfilePictureBase64(null);
              setProfilePictureMimeType(DEFAULT_PROFILE_MIME_TYPE);
            }
        }
    }



    /* if(firstLoginCheck === false)
    { 
        return(
          <> 
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link as={Link} to="/" >Home</Nav.Link>
                <NavDropdown title="Dashboard" id="basic-nav-dropdown">
                  <NavDropdown.Item as={Link} to="/assetmanager" disabled>Asset Manager</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/profile" disabled>Profile</NavDropdown.Item>
                </NavDropdown>                  
              </Nav>
            </Navbar.Collapse>

            <Spinner animation="border" variant="success"/>
          </>
        )
    }
    else{ */
        // Based on the current 'loginstatus', display message and buttons in the NavBar.
        if(state.loginstatus === LOGIN_STATUS.SIGNED_OUT) 
        {
            return (
              <>
                <Navbar.Collapse id="site-navbar-collapse">
                  <Nav
                    className="site-navbar-links me-auto"
                  >
                    <Nav.Link as={Link} to="/" >Home</Nav.Link>
                    <Nav.Link href="/assetmanager" disabled>Asset Manager</Nav.Link>
                    <Nav.Link href="/profile" disabled>Profile</Nav.Link>
                    <Nav.Link as={NavLink} to="/faq" onClick={() => setNavbarExpanded(false)}>FAQ</Nav.Link>
                  </Nav>
                </Navbar.Collapse>

                <Navbar.Collapse className="justify-content-end">
                    <Form className="site-navbar-signin-form" onSubmit={signIn}>
                      <Row className="site-navbar-signin-row" style={{display: 'flex', justifyContent: 'center'}}>
                        <Col xs="auto">
                            <Form.Group controlId="formBasicEmail">
                                <Form.Control
                                  className="site-navbar-auth-input mb-2"
                                  ref={usernameRef}
                                  type="email" 
                                  placeholder="Email"
                                />
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            <Form.Group controlId="formBasicPassword">
                                <FormControl 
                                  className="site-navbar-auth-input mb-2"
                                  ref={passwordRef}
                                  placeholder="Password" 
                                  type="password"
                                />
                          </Form.Group>
                        </Col>
                        <Col xs="auto">
                          <Button className="site-auth-button site-navbar-signin-button" type='submit' variant="success">
                            <b>SignIn</b>
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                </Navbar.Collapse>
              </>       
            );
        }
        else if(state.loginstatus === LOGIN_STATUS.SIGNING_IN)
        {
            return (
              <>
                <Navbar.Collapse id="site-navbar-collapse">
                  <Nav
                    className="site-navbar-links me-auto"
                  >
                    <Nav.Link as={Link} to="/" >Home</Nav.Link>
                    <Nav.Link as={Link} to="/assetmanager" disabled>Asset Manager</Nav.Link>
                    <Nav.Link as={Link} to="/profile" disabled>Profile</Nav.Link>
                    <Nav.Link as={NavLink} to="/faq" onClick={() => setNavbarExpanded(false)}>FAQ</Nav.Link>
                    {/* <NavDropdown title="Dashboard" id="basic-nav-dropdown">
                        <NavDropdown.Item as={Link} to="/assetmanager" disabled>Asset Manager</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/profile" disabled>Profile</NavDropdown.Item>
                    </NavDropdown>                   */}
                  </Nav>
                </Navbar.Collapse>

                <Navbar.Collapse className="justify-content-end">
                    <div className="site-navbar-account">
                    <Spinner
                          as="span"
                          animation="border"
                          variant="success"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                    <Navbar.Text style={{marginLeft: '5px'}}>
                        Signing in
                    </Navbar.Text>
                    <Button className="site-auth-button site-navbar-signout" variant="danger" onClick={signOut} disabled> <b>SignOut</b> </Button>
                    </div>
                </Navbar.Collapse>
              </>
            );
        }
        else if(state.loginstatus === LOGIN_STATUS.SIGNED_IN)
        {
            return (
              <>
                <Navbar.Collapse id="site-navbar-collapse">
                  <Nav
                    className="site-navbar-links me-auto"
                  >
                    <Nav.Link as={Link} to="/" >Home</Nav.Link>
                    <Nav.Link as={Link} to="/assetmanager" >Asset Manager</Nav.Link>
                    <Nav.Link as={Link} to="/profile" >Profile</Nav.Link>
                    <Nav.Link as={NavLink} to="/faq" onClick={() => setNavbarExpanded(false)}>FAQ</Nav.Link>
                    {/* <NavDropdown title="Dashboard" id="basic-nav-dropdown">
                        <NavDropdown.Item as={Link} to="/assetmanager">Asset Manager</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/profile">Profile</NavDropdown.Item>
                    </NavDropdown> */}                  
                  </Nav>
                </Navbar.Collapse>

                <Navbar.Collapse className="justify-content-end">
                    <div className="site-navbar-account">
                    {image_icon_uploaded
                    ? <Image className="site-navbar-avatar" src={`data:${profilePictureMimeType};base64,${profilePictureBase64}`} alt="Profile" height="36" roundedCircle/>
                    : (individual_or_company === 'Individual')
                      ? <Image className="site-navbar-avatar" src={individual} alt="Individual account" height="36" roundedCircle/>
                      : <Image className="site-navbar-avatar" src={company} alt="Company account" height="36" roundedCircle/>
                    }
                        
                    <Navbar.Text className="site-navbar-user">
                        Logged in as, <a href="#login"> {state.name} </a>
                    </Navbar.Text>
                    <Button className="site-auth-button site-navbar-signout" variant="danger" onClick={signOut}> <b>SignOut</b> </Button>
                    </div>
                </Navbar.Collapse>
              </>
            );
        }
        else if(state.loginstatus === LOGIN_STATUS.SIGNING_OUT)
        {
            return (
              <>
                <Navbar.Collapse id="site-navbar-collapse">
                  <Nav
                    className="site-navbar-links me-auto"
                  >
                    <Nav.Link as={Link} to="/" >Home</Nav.Link>
                    <Nav.Link as={Link} to="/assetmanager" >Asset Manager</Nav.Link>
                    <Nav.Link as={Link} to="/profile" >Profile</Nav.Link>
                    <Nav.Link as={NavLink} to="/faq" onClick={() => setNavbarExpanded(false)}>FAQ</Nav.Link>
                    {/* <NavDropdown title="Dashboard" id="basic-nav-dropdown">
                        <NavDropdown.Item as={Link} to="/assetmanager" disabled>Asset Manager</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/profile" disabled>Profile</NavDropdown.Item>
                    </NavDropdown> */}                  
                  </Nav>
                </Navbar.Collapse>

                <Navbar.Collapse className="justify-content-end">
                    <div className="site-navbar-account">
                    <Spinner
                          as="span"
                          animation="border"
                          variant="danger"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                    <Navbar.Text style={{marginLeft: '5px'}}>
                        Signing out
                    </Navbar.Text>
                    <Button className="site-auth-button site-navbar-signout" variant="danger" onClick={signOut} disabled> <b>SignOut</b> </Button>
                    </div>
                </Navbar.Collapse>
              </>
            );
        }
}


export default App;

